import React from 'react'
import PropTypes from 'prop-types'
import {
  Table,
  TableRow,
  TableBody,
  TableCell
} from '@/components/ui/table'


const CustomTable = (props) => {
  const { data } = props

  return (
    <div className='shadow-lg bg-white'>
      <Table className='border'>
        <TableBody>
          {
            data?.map((item, i) => (
              <TableRow className='hover:bg-inherit' key={i}>
                <TableCell className='text-lg font-medium w-1/2 border-r px-4 py-3'>{item?.label}</TableCell>
                <TableCell className='text-lg font-medium w-1/2 px-4 py-3'>{item?.value}</TableCell>
              </TableRow>
            ))
          }
        </TableBody>
      </Table>
    </div>
  )
}

CustomTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  }))
}

export default CustomTable
